import { KeycloakProvider } from 'contexts/keycloak'

import { useAuthGate } from './auth-gate.model'
import type { IAuthGateProps } from './auth-gate.types'
import { AuthGateView } from './auth-gate.view'

// Runs INSIDE the providers so `useAuthGate`'s `useKeycloak`/`useMe` see their context, and keeps
// the view a pure function of the computed state.
function AuthGateContent({ children }: IAuthGateProps) {
  const state = useAuthGate()
  return <AuthGateView state={state}>{children}</AuthGateView>
}

/**
 * Auth boundary that replaced the `winninAuth` MFE wrapper. Mounted below the host
 * `ApolloProvider` in `index.tsx`, so `useMe` uses the host Apollo client directly — no
 * second provider here. `<KeycloakProvider>` runs `keycloak.init()` once.
 */
export function AuthGate({ children }: IAuthGateProps) {
  return (
    <KeycloakProvider>
      <AuthGateContent>{children}</AuthGateContent>
    </KeycloakProvider>
  )
}
